/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PayoutsRouteImport } from './routes/payouts'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StorageRefreshIndexRouteImport } from './routes/storage-refresh.index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as RunsIndexRouteImport } from './routes/runs.index'
import { Route as QueuesIndexRouteImport } from './routes/queues.index'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as PnlIndexRouteImport } from './routes/pnl.index'
import { Route as OrdersIndexRouteImport } from './routes/orders.index'
import { Route as KeywordsIndexRouteImport } from './routes/keywords.index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as CampaignsIndexRouteImport } from './routes/campaigns.index'
import { Route as StudioHistoryRouteImport } from './routes/studio_.history'
import { Route as SettingsValueRecoveryRouteImport } from './routes/settings.value-recovery'
import { Route as SettingsSchedulesRouteImport } from './routes/settings.schedules'
import { Route as SettingsListingAutomationRouteImport } from './routes/settings.listing-automation'
import { Route as RunsSlugRouteImport } from './routes/runs.$slug'
import { Route as ProductsSkuRouteImport } from './routes/products.$sku'
import { Route as DashboardMarketplaceRouteImport } from './routes/dashboard.$marketplace'
import { Route as StorageRefreshMarketplaceIndexRouteImport } from './routes/storage-refresh.$marketplace.index'
import { Route as SettingsSchedulesIndexRouteImport } from './routes/settings.schedules.index'
import { Route as RunsSlugIndexRouteImport } from './routes/runs.$slug.index'
import { Route as PnlMarketplaceIndexRouteImport } from './routes/pnl.$marketplace.index'
import { Route as KeywordsMarketplaceIndexRouteImport } from './routes/keywords.$marketplace.index'
import { Route as CampaignsMarketplaceIndexRouteImport } from './routes/campaigns.$marketplace.index'
import { Route as SettingsSchedulesJobIdRouteImport } from './routes/settings.schedules.$jobId'
import { Route as OrdersMarketplaceOrderIdRouteImport } from './routes/orders.$marketplace.$orderId'
import { Route as KeywordsMarketplacePhraseRouteImport } from './routes/keywords.$marketplace.$phrase'
import { Route as SettingsSchedulesJobIdIndexRouteImport } from './routes/settings.schedules.$jobId.index'
import { Route as SettingsSchedulesJobIdScheduleRouteImport } from './routes/settings.schedules.$jobId.schedule'
import { Route as SettingsSchedulesJobIdHistoryRouteImport } from './routes/settings.schedules.$jobId.history'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutsRoute = PayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StorageRefreshIndexRoute = StorageRefreshIndexRouteImport.update({
  id: '/storage-refresh/',
  path: '/storage-refresh/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const RunsIndexRoute = RunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => rootRouteImport,
} as any)
const QueuesIndexRoute = QueuesIndexRouteImport.update({
  id: '/queues/',
  path: '/queues/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const PnlIndexRoute = PnlIndexRouteImport.update({
  id: '/pnl/',
  path: '/pnl/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const KeywordsIndexRoute = KeywordsIndexRouteImport.update({
  id: '/keywords/',
  path: '/keywords/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioHistoryRoute = StudioHistoryRouteImport.update({
  id: '/studio_/history',
  path: '/studio/history',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsValueRecoveryRoute = SettingsValueRecoveryRouteImport.update({
  id: '/value-recovery',
  path: '/value-recovery',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSchedulesRoute = SettingsSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsListingAutomationRoute =
  SettingsListingAutomationRouteImport.update({
    id: '/listing-automation',
    path: '/listing-automation',
    getParentRoute: () => SettingsRoute,
  } as any)
const RunsSlugRoute = RunsSlugRouteImport.update({
  id: '/runs/$slug',
  path: '/runs/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsSkuRoute = ProductsSkuRouteImport.update({
  id: '/products/$sku',
  path: '/products/$sku',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardMarketplaceRoute = DashboardMarketplaceRouteImport.update({
  id: '/dashboard/$marketplace',
  path: '/dashboard/$marketplace',
  getParentRoute: () => rootRouteImport,
} as any)
const StorageRefreshMarketplaceIndexRoute =
  StorageRefreshMarketplaceIndexRouteImport.update({
    id: '/storage-refresh/$marketplace/',
    path: '/storage-refresh/$marketplace/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsSchedulesIndexRoute = SettingsSchedulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsSchedulesRoute,
} as any)
const RunsSlugIndexRoute = RunsSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RunsSlugRoute,
} as any)
const PnlMarketplaceIndexRoute = PnlMarketplaceIndexRouteImport.update({
  id: '/pnl/$marketplace/',
  path: '/pnl/$marketplace/',
  getParentRoute: () => rootRouteImport,
} as any)
const KeywordsMarketplaceIndexRoute =
  KeywordsMarketplaceIndexRouteImport.update({
    id: '/keywords/$marketplace/',
    path: '/keywords/$marketplace/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CampaignsMarketplaceIndexRoute =
  CampaignsMarketplaceIndexRouteImport.update({
    id: '/campaigns/$marketplace/',
    path: '/campaigns/$marketplace/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsSchedulesJobIdRoute = SettingsSchedulesJobIdRouteImport.update({
  id: '/$jobId',
  path: '/$jobId',
  getParentRoute: () => SettingsSchedulesRoute,
} as any)
const OrdersMarketplaceOrderIdRoute =
  OrdersMarketplaceOrderIdRouteImport.update({
    id: '/orders/$marketplace/$orderId',
    path: '/orders/$marketplace/$orderId',
    getParentRoute: () => rootRouteImport,
  } as any)
const KeywordsMarketplacePhraseRoute =
  KeywordsMarketplacePhraseRouteImport.update({
    id: '/keywords/$marketplace/$phrase',
    path: '/keywords/$marketplace/$phrase',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsSchedulesJobIdIndexRoute =
  SettingsSchedulesJobIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SettingsSchedulesJobIdRoute,
  } as any)
const SettingsSchedulesJobIdScheduleRoute =
  SettingsSchedulesJobIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => SettingsSchedulesJobIdRoute,
  } as any)
const SettingsSchedulesJobIdHistoryRoute =
  SettingsSchedulesJobIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => SettingsSchedulesJobIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/payouts': typeof PayoutsRoute
  '/settings': typeof SettingsRouteWithChildren
  '/studio': typeof StudioRoute
  '/users': typeof UsersRoute
  '/dashboard/$marketplace': typeof DashboardMarketplaceRoute
  '/products/$sku': typeof ProductsSkuRoute
  '/runs/$slug': typeof RunsSlugRouteWithChildren
  '/settings/listing-automation': typeof SettingsListingAutomationRoute
  '/settings/schedules': typeof SettingsSchedulesRouteWithChildren
  '/settings/value-recovery': typeof SettingsValueRecoveryRoute
  '/studio/history': typeof StudioHistoryRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/keywords/': typeof KeywordsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/pnl/': typeof PnlIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/queues/': typeof QueuesIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/storage-refresh/': typeof StorageRefreshIndexRoute
  '/keywords/$marketplace/$phrase': typeof KeywordsMarketplacePhraseRoute
  '/orders/$marketplace/$orderId': typeof OrdersMarketplaceOrderIdRoute
  '/settings/schedules/$jobId': typeof SettingsSchedulesJobIdRouteWithChildren
  '/campaigns/$marketplace/': typeof CampaignsMarketplaceIndexRoute
  '/keywords/$marketplace/': typeof KeywordsMarketplaceIndexRoute
  '/pnl/$marketplace/': typeof PnlMarketplaceIndexRoute
  '/runs/$slug/': typeof RunsSlugIndexRoute
  '/settings/schedules/': typeof SettingsSchedulesIndexRoute
  '/storage-refresh/$marketplace/': typeof StorageRefreshMarketplaceIndexRoute
  '/settings/schedules/$jobId/history': typeof SettingsSchedulesJobIdHistoryRoute
  '/settings/schedules/$jobId/schedule': typeof SettingsSchedulesJobIdScheduleRoute
  '/settings/schedules/$jobId/': typeof SettingsSchedulesJobIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/payouts': typeof PayoutsRoute
  '/studio': typeof StudioRoute
  '/users': typeof UsersRoute
  '/dashboard/$marketplace': typeof DashboardMarketplaceRoute
  '/products/$sku': typeof ProductsSkuRoute
  '/settings/listing-automation': typeof SettingsListingAutomationRoute
  '/settings/value-recovery': typeof SettingsValueRecoveryRoute
  '/studio/history': typeof StudioHistoryRoute
  '/campaigns': typeof CampaignsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/keywords': typeof KeywordsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/pnl': typeof PnlIndexRoute
  '/products': typeof ProductsIndexRoute
  '/queues': typeof QueuesIndexRoute
  '/runs': typeof RunsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/storage-refresh': typeof StorageRefreshIndexRoute
  '/keywords/$marketplace/$phrase': typeof KeywordsMarketplacePhraseRoute
  '/orders/$marketplace/$orderId': typeof OrdersMarketplaceOrderIdRoute
  '/campaigns/$marketplace': typeof CampaignsMarketplaceIndexRoute
  '/keywords/$marketplace': typeof KeywordsMarketplaceIndexRoute
  '/pnl/$marketplace': typeof PnlMarketplaceIndexRoute
  '/runs/$slug': typeof RunsSlugIndexRoute
  '/settings/schedules': typeof SettingsSchedulesIndexRoute
  '/storage-refresh/$marketplace': typeof StorageRefreshMarketplaceIndexRoute
  '/settings/schedules/$jobId/history': typeof SettingsSchedulesJobIdHistoryRoute
  '/settings/schedules/$jobId/schedule': typeof SettingsSchedulesJobIdScheduleRoute
  '/settings/schedules/$jobId': typeof SettingsSchedulesJobIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/payouts': typeof PayoutsRoute
  '/settings': typeof SettingsRouteWithChildren
  '/studio': typeof StudioRoute
  '/users': typeof UsersRoute
  '/dashboard/$marketplace': typeof DashboardMarketplaceRoute
  '/products/$sku': typeof ProductsSkuRoute
  '/runs/$slug': typeof RunsSlugRouteWithChildren
  '/settings/listing-automation': typeof SettingsListingAutomationRoute
  '/settings/schedules': typeof SettingsSchedulesRouteWithChildren
  '/settings/value-recovery': typeof SettingsValueRecoveryRoute
  '/studio_/history': typeof StudioHistoryRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/keywords/': typeof KeywordsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/pnl/': typeof PnlIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/queues/': typeof QueuesIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/storage-refresh/': typeof StorageRefreshIndexRoute
  '/keywords/$marketplace/$phrase': typeof KeywordsMarketplacePhraseRoute
  '/orders/$marketplace/$orderId': typeof OrdersMarketplaceOrderIdRoute
  '/settings/schedules/$jobId': typeof SettingsSchedulesJobIdRouteWithChildren
  '/campaigns/$marketplace/': typeof CampaignsMarketplaceIndexRoute
  '/keywords/$marketplace/': typeof KeywordsMarketplaceIndexRoute
  '/pnl/$marketplace/': typeof PnlMarketplaceIndexRoute
  '/runs/$slug/': typeof RunsSlugIndexRoute
  '/settings/schedules/': typeof SettingsSchedulesIndexRoute
  '/storage-refresh/$marketplace/': typeof StorageRefreshMarketplaceIndexRoute
  '/settings/schedules/$jobId/history': typeof SettingsSchedulesJobIdHistoryRoute
  '/settings/schedules/$jobId/schedule': typeof SettingsSchedulesJobIdScheduleRoute
  '/settings/schedules/$jobId/': typeof SettingsSchedulesJobIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/payouts'
    | '/settings'
    | '/studio'
    | '/users'
    | '/dashboard/$marketplace'
    | '/products/$sku'
    | '/runs/$slug'
    | '/settings/listing-automation'
    | '/settings/schedules'
    | '/settings/value-recovery'
    | '/studio/history'
    | '/campaigns/'
    | '/dashboard/'
    | '/keywords/'
    | '/orders/'
    | '/pnl/'
    | '/products/'
    | '/queues/'
    | '/runs/'
    | '/settings/'
    | '/storage-refresh/'
    | '/keywords/$marketplace/$phrase'
    | '/orders/$marketplace/$orderId'
    | '/settings/schedules/$jobId'
    | '/campaigns/$marketplace/'
    | '/keywords/$marketplace/'
    | '/pnl/$marketplace/'
    | '/runs/$slug/'
    | '/settings/schedules/'
    | '/storage-refresh/$marketplace/'
    | '/settings/schedules/$jobId/history'
    | '/settings/schedules/$jobId/schedule'
    | '/settings/schedules/$jobId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/payouts'
    | '/studio'
    | '/users'
    | '/dashboard/$marketplace'
    | '/products/$sku'
    | '/settings/listing-automation'
    | '/settings/value-recovery'
    | '/studio/history'
    | '/campaigns'
    | '/dashboard'
    | '/keywords'
    | '/orders'
    | '/pnl'
    | '/products'
    | '/queues'
    | '/runs'
    | '/settings'
    | '/storage-refresh'
    | '/keywords/$marketplace/$phrase'
    | '/orders/$marketplace/$orderId'
    | '/campaigns/$marketplace'
    | '/keywords/$marketplace'
    | '/pnl/$marketplace'
    | '/runs/$slug'
    | '/settings/schedules'
    | '/storage-refresh/$marketplace'
    | '/settings/schedules/$jobId/history'
    | '/settings/schedules/$jobId/schedule'
    | '/settings/schedules/$jobId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/payouts'
    | '/settings'
    | '/studio'
    | '/users'
    | '/dashboard/$marketplace'
    | '/products/$sku'
    | '/runs/$slug'
    | '/settings/listing-automation'
    | '/settings/schedules'
    | '/settings/value-recovery'
    | '/studio_/history'
    | '/campaigns/'
    | '/dashboard/'
    | '/keywords/'
    | '/orders/'
    | '/pnl/'
    | '/products/'
    | '/queues/'
    | '/runs/'
    | '/settings/'
    | '/storage-refresh/'
    | '/keywords/$marketplace/$phrase'
    | '/orders/$marketplace/$orderId'
    | '/settings/schedules/$jobId'
    | '/campaigns/$marketplace/'
    | '/keywords/$marketplace/'
    | '/pnl/$marketplace/'
    | '/runs/$slug/'
    | '/settings/schedules/'
    | '/storage-refresh/$marketplace/'
    | '/settings/schedules/$jobId/history'
    | '/settings/schedules/$jobId/schedule'
    | '/settings/schedules/$jobId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  PayoutsRoute: typeof PayoutsRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  StudioRoute: typeof StudioRoute
  UsersRoute: typeof UsersRoute
  DashboardMarketplaceRoute: typeof DashboardMarketplaceRoute
  ProductsSkuRoute: typeof ProductsSkuRoute
  RunsSlugRoute: typeof RunsSlugRouteWithChildren
  StudioHistoryRoute: typeof StudioHistoryRoute
  CampaignsIndexRoute: typeof CampaignsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  KeywordsIndexRoute: typeof KeywordsIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  PnlIndexRoute: typeof PnlIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  QueuesIndexRoute: typeof QueuesIndexRoute
  RunsIndexRoute: typeof RunsIndexRoute
  StorageRefreshIndexRoute: typeof StorageRefreshIndexRoute
  KeywordsMarketplacePhraseRoute: typeof KeywordsMarketplacePhraseRoute
  OrdersMarketplaceOrderIdRoute: typeof OrdersMarketplaceOrderIdRoute
  CampaignsMarketplaceIndexRoute: typeof CampaignsMarketplaceIndexRoute
  KeywordsMarketplaceIndexRoute: typeof KeywordsMarketplaceIndexRoute
  PnlMarketplaceIndexRoute: typeof PnlMarketplaceIndexRoute
  StorageRefreshMarketplaceIndexRoute: typeof StorageRefreshMarketplaceIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payouts': {
      id: '/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof PayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storage-refresh/': {
      id: '/storage-refresh/'
      path: '/storage-refresh'
      fullPath: '/storage-refresh/'
      preLoaderRoute: typeof StorageRefreshIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/runs/': {
      id: '/runs/'
      path: '/runs'
      fullPath: '/runs/'
      preLoaderRoute: typeof RunsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/queues/': {
      id: '/queues/'
      path: '/queues'
      fullPath: '/queues/'
      preLoaderRoute: typeof QueuesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pnl/': {
      id: '/pnl/'
      path: '/pnl'
      fullPath: '/pnl/'
      preLoaderRoute: typeof PnlIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/keywords/': {
      id: '/keywords/'
      path: '/keywords'
      fullPath: '/keywords/'
      preLoaderRoute: typeof KeywordsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof CampaignsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio_/history': {
      id: '/studio_/history'
      path: '/studio/history'
      fullPath: '/studio/history'
      preLoaderRoute: typeof StudioHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/value-recovery': {
      id: '/settings/value-recovery'
      path: '/value-recovery'
      fullPath: '/settings/value-recovery'
      preLoaderRoute: typeof SettingsValueRecoveryRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/schedules': {
      id: '/settings/schedules'
      path: '/schedules'
      fullPath: '/settings/schedules'
      preLoaderRoute: typeof SettingsSchedulesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/listing-automation': {
      id: '/settings/listing-automation'
      path: '/listing-automation'
      fullPath: '/settings/listing-automation'
      preLoaderRoute: typeof SettingsListingAutomationRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/runs/$slug': {
      id: '/runs/$slug'
      path: '/runs/$slug'
      fullPath: '/runs/$slug'
      preLoaderRoute: typeof RunsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$sku': {
      id: '/products/$sku'
      path: '/products/$sku'
      fullPath: '/products/$sku'
      preLoaderRoute: typeof ProductsSkuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/$marketplace': {
      id: '/dashboard/$marketplace'
      path: '/dashboard/$marketplace'
      fullPath: '/dashboard/$marketplace'
      preLoaderRoute: typeof DashboardMarketplaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storage-refresh/$marketplace/': {
      id: '/storage-refresh/$marketplace/'
      path: '/storage-refresh/$marketplace'
      fullPath: '/storage-refresh/$marketplace/'
      preLoaderRoute: typeof StorageRefreshMarketplaceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/schedules/': {
      id: '/settings/schedules/'
      path: '/'
      fullPath: '/settings/schedules/'
      preLoaderRoute: typeof SettingsSchedulesIndexRouteImport
      parentRoute: typeof SettingsSchedulesRoute
    }
    '/runs/$slug/': {
      id: '/runs/$slug/'
      path: '/'
      fullPath: '/runs/$slug/'
      preLoaderRoute: typeof RunsSlugIndexRouteImport
      parentRoute: typeof RunsSlugRoute
    }
    '/pnl/$marketplace/': {
      id: '/pnl/$marketplace/'
      path: '/pnl/$marketplace'
      fullPath: '/pnl/$marketplace/'
      preLoaderRoute: typeof PnlMarketplaceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/keywords/$marketplace/': {
      id: '/keywords/$marketplace/'
      path: '/keywords/$marketplace'
      fullPath: '/keywords/$marketplace/'
      preLoaderRoute: typeof KeywordsMarketplaceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/$marketplace/': {
      id: '/campaigns/$marketplace/'
      path: '/campaigns/$marketplace'
      fullPath: '/campaigns/$marketplace/'
      preLoaderRoute: typeof CampaignsMarketplaceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/schedules/$jobId': {
      id: '/settings/schedules/$jobId'
      path: '/$jobId'
      fullPath: '/settings/schedules/$jobId'
      preLoaderRoute: typeof SettingsSchedulesJobIdRouteImport
      parentRoute: typeof SettingsSchedulesRoute
    }
    '/orders/$marketplace/$orderId': {
      id: '/orders/$marketplace/$orderId'
      path: '/orders/$marketplace/$orderId'
      fullPath: '/orders/$marketplace/$orderId'
      preLoaderRoute: typeof OrdersMarketplaceOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/keywords/$marketplace/$phrase': {
      id: '/keywords/$marketplace/$phrase'
      path: '/keywords/$marketplace/$phrase'
      fullPath: '/keywords/$marketplace/$phrase'
      preLoaderRoute: typeof KeywordsMarketplacePhraseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/schedules/$jobId/': {
      id: '/settings/schedules/$jobId/'
      path: '/'
      fullPath: '/settings/schedules/$jobId/'
      preLoaderRoute: typeof SettingsSchedulesJobIdIndexRouteImport
      parentRoute: typeof SettingsSchedulesJobIdRoute
    }
    '/settings/schedules/$jobId/schedule': {
      id: '/settings/schedules/$jobId/schedule'
      path: '/schedule'
      fullPath: '/settings/schedules/$jobId/schedule'
      preLoaderRoute: typeof SettingsSchedulesJobIdScheduleRouteImport
      parentRoute: typeof SettingsSchedulesJobIdRoute
    }
    '/settings/schedules/$jobId/history': {
      id: '/settings/schedules/$jobId/history'
      path: '/history'
      fullPath: '/settings/schedules/$jobId/history'
      preLoaderRoute: typeof SettingsSchedulesJobIdHistoryRouteImport
      parentRoute: typeof SettingsSchedulesJobIdRoute
    }
  }
}

interface SettingsSchedulesJobIdRouteChildren {
  SettingsSchedulesJobIdHistoryRoute: typeof SettingsSchedulesJobIdHistoryRoute
  SettingsSchedulesJobIdScheduleRoute: typeof SettingsSchedulesJobIdScheduleRoute
  SettingsSchedulesJobIdIndexRoute: typeof SettingsSchedulesJobIdIndexRoute
}

const SettingsSchedulesJobIdRouteChildren: SettingsSchedulesJobIdRouteChildren =
  {
    SettingsSchedulesJobIdHistoryRoute: SettingsSchedulesJobIdHistoryRoute,
    SettingsSchedulesJobIdScheduleRoute: SettingsSchedulesJobIdScheduleRoute,
    SettingsSchedulesJobIdIndexRoute: SettingsSchedulesJobIdIndexRoute,
  }

const SettingsSchedulesJobIdRouteWithChildren =
  SettingsSchedulesJobIdRoute._addFileChildren(
    SettingsSchedulesJobIdRouteChildren,
  )

interface SettingsSchedulesRouteChildren {
  SettingsSchedulesJobIdRoute: typeof SettingsSchedulesJobIdRouteWithChildren
  SettingsSchedulesIndexRoute: typeof SettingsSchedulesIndexRoute
}

const SettingsSchedulesRouteChildren: SettingsSchedulesRouteChildren = {
  SettingsSchedulesJobIdRoute: SettingsSchedulesJobIdRouteWithChildren,
  SettingsSchedulesIndexRoute: SettingsSchedulesIndexRoute,
}

const SettingsSchedulesRouteWithChildren =
  SettingsSchedulesRoute._addFileChildren(SettingsSchedulesRouteChildren)

interface SettingsRouteChildren {
  SettingsListingAutomationRoute: typeof SettingsListingAutomationRoute
  SettingsSchedulesRoute: typeof SettingsSchedulesRouteWithChildren
  SettingsValueRecoveryRoute: typeof SettingsValueRecoveryRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsListingAutomationRoute: SettingsListingAutomationRoute,
  SettingsSchedulesRoute: SettingsSchedulesRouteWithChildren,
  SettingsValueRecoveryRoute: SettingsValueRecoveryRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface RunsSlugRouteChildren {
  RunsSlugIndexRoute: typeof RunsSlugIndexRoute
}

const RunsSlugRouteChildren: RunsSlugRouteChildren = {
  RunsSlugIndexRoute: RunsSlugIndexRoute,
}

const RunsSlugRouteWithChildren = RunsSlugRoute._addFileChildren(
  RunsSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  PayoutsRoute: PayoutsRoute,
  SettingsRoute: SettingsRouteWithChildren,
  StudioRoute: StudioRoute,
  UsersRoute: UsersRoute,
  DashboardMarketplaceRoute: DashboardMarketplaceRoute,
  ProductsSkuRoute: ProductsSkuRoute,
  RunsSlugRoute: RunsSlugRouteWithChildren,
  StudioHistoryRoute: StudioHistoryRoute,
  CampaignsIndexRoute: CampaignsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  KeywordsIndexRoute: KeywordsIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  PnlIndexRoute: PnlIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  QueuesIndexRoute: QueuesIndexRoute,
  RunsIndexRoute: RunsIndexRoute,
  StorageRefreshIndexRoute: StorageRefreshIndexRoute,
  KeywordsMarketplacePhraseRoute: KeywordsMarketplacePhraseRoute,
  OrdersMarketplaceOrderIdRoute: OrdersMarketplaceOrderIdRoute,
  CampaignsMarketplaceIndexRoute: CampaignsMarketplaceIndexRoute,
  KeywordsMarketplaceIndexRoute: KeywordsMarketplaceIndexRoute,
  PnlMarketplaceIndexRoute: PnlMarketplaceIndexRoute,
  StorageRefreshMarketplaceIndexRoute: StorageRefreshMarketplaceIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
